import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/StrategicConsulting/4.jpg";
import { FaCalendarAlt, FaCogs, FaCompass, FaPaintBrush, FaReact, FaUserAlt } from "react-icons/fa"
import {GoGraph} from "react-icons/go"
import {MdAssessment} from "react-icons/md"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Migration Roadmap
            </h1>
            <p className="text-lg text-gray-600">
            Create a detailed migration plan to transition seamlessly to public, private, or hybrid cloud environments.
			      </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaCogs className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Testing & Optimization</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Test applications in the cloud and optimize for performance and cost.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdAssessment className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Assessment & Planning
                </h3>         
              </div>
              <p className="text-gray-600 text-sm">
              Evaluate current infrastructure and decide on the best cloud strategy.
              </p>
            </div>


          </div>
        </div>

      
      </div>
    </div>
  )
}